import React from 'react';
import { Location } from 'history';
import { Switch, Route } from 'react-router';
import AuthorizedLayout from '../layouts/auth/AuthorizedLayout';
import {
    ProfilePage,
    NotFoundPage,
    ExamListPage,
    AccountConfirmationPage,
    EmailConfirmationPage,
    QualificationsListPage,
    ConductRequestsListPage, ExamDetailsPage, DetailsPage, UsersPage,
} from '../pages';
import { ErrorBoundary } from 'components';

interface AuthorizedHandlerProps {
    location: Location;
}

const AuthorizedHandler = (props: AuthorizedHandlerProps) => {
    const { location } = props;
    return (
        <AuthorizedLayout location={location}>
            <React.Suspense fallback={<div>Loading...</div>}>
                <ErrorBoundary>
                    <Switch location={location}>
                        <Route path="/my-profile" component={ProfilePage} />

                        <Route path="/conduct-requests" component={ConductRequestsListPage} />
                        <Route path="/exam-list" component={ExamListPage} />
                        <Route path="/exam/:examId" component={ExamDetailsPage} />

                        <Route path="/users" component={UsersPage} />
                        <Route path="/qualifications" component={QualificationsListPage} />
                        <Route path="/details" component={DetailsPage} />

                        <Route path="/confirm/:token" component={AccountConfirmationPage} />
                        <Route path="/confirm-email/:token/" component={EmailConfirmationPage} />
                        <Route component={NotFoundPage} />
                    </Switch>
                </ErrorBoundary>
            </React.Suspense>
        </AuthorizedLayout>
    );
};

export default AuthorizedHandler;
